import { render, staticRenderFns } from "./sloganCard.vue?vue&type=template&id=5728ffdf&scoped=true&"
import script from "./sloganCard.vue?vue&type=script&lang=js&"
export * from "./sloganCard.vue?vue&type=script&lang=js&"
import style0 from "./sloganCard.vue?vue&type=style&index=0&id=5728ffdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5728ffdf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
